var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobileBlueVector = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 354,
    viewBox: "0 0 393 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M775.199 352.696L362.079 66.8993C256.069 -6.43968 115.01 -20.8315 -11.6674 37.4132C-105.068 80.3557 -199.182 172.517 -230.011 205.001",
    stroke: "#3AC2CE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobileBlueVector);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile_blue_vector.4e354a2f81e2579e148e0e6c19df0051.svg";